import React from 'react';
import { FontAwesomeIcon, FontAwesomeIconProps } from '@fortawesome/react-fontawesome';

interface IconPropsBase {
  showBubble?: boolean;
  bubbleClassName?: string;
  bubbleText?: string;
}

type IconProps = FontAwesomeIconProps & IconPropsBase & React.HTMLAttributes<HTMLButtonElement>;

function Icon(props: IconProps) {
  const { showBubble, bubbleClassName, bubbleText, ...rest } = props;

  const bubbleClasses = [
    'absolute rounded-full text-white font-semibold grid justify-center items-center',
  ];

  if (bubbleClassName) {
    bubbleClasses.push(bubbleClassName);
  }

  const bubbleSizeIfText = { bottom: '-5px', right: '-5px', width: '15px', height: '15px' };
  const bubbleSizeIfNoText = {
    bottom: '-2px',
    right: '-2px',
    width: '10px',
    height: '10px',
  };

  const bubbleSize = bubbleText ? bubbleSizeIfText : bubbleSizeIfNoText;

  return (
    <span className="relative">
      <FontAwesomeIcon fixedWidth {...rest} />
      <div
        style={{
          fontSize: '0.6rem',
          lineHeight: 0,
          opacity: showBubble ? 1 : 0,
          transform: showBubble ? 'scale(1)' : 'scale(0.5)',
          transition: 'opacity 0.2s, transform 0.2s',
          pointerEvents: showBubble ? 'auto' : 'none',
          ...bubbleSize,
        }}
        className={bubbleClasses.join(' ')}
      >
        {bubbleText}
      </div>
    </span>
  );
}

export default Icon;
